import { Icon } from '@examdojo/core/icon';
import { Proficiency } from '@examdojo/models/proficiency/proficiency.model';
import { TableInsertModel, TableRowModel, TableUpdateModel } from '@examdojo/supabase';
import { CourseLevel } from '../model';
import { SyllabusStoreModel } from '../syllabus';
import { TopicLevel1UIModel } from '../topic-level-1';

export type TopicLevel2HttpModel = Pick<
  TableRowModel<'topics_level_02', 'categories'>,
  | 'code'
  | 'course_level'
  | 'course_levels'
  | 'created_at'
  | 'description'
  | 'example'
  | 'id'
  | 'name'
  | 'sort_order'
  | 'topic_level_01_id'
  | 'updated_at'
  | 'active'
  | 'icon'
  | 'short_name'
>;

export type TopicLevel2StoreModel = Omit<
  TopicLevel2HttpModel,
  'name' | 'description' | 'example' | 'icon' | 'short_name'
> & {
  name: string;
  description: string;
  example: string;
  short_name: string;
  slug: string;
  icon: Icon | null;
};

export type TopicLevel2UIModel = TopicLevel2StoreModel & {
  topicLevel1?: TopicLevel1UIModel;
  codeNumber: string;
  weight?: TopicLevel2Weight;
  proficiency?: Proficiency;
};

export const TOPIC_LEVEL_2_CREATE_ALLOWED_KEYS = [
  'code',
  'course_level',
  'description',
  'example',
  'name',
  'sort_order',
  'topic_level_01_id',
] satisfies Array<keyof TableInsertModel<'topics_level_02', 'categories'>>;

export type TopicLevel2CreateModel = Pick<
  TableInsertModel<'topics_level_02', 'categories'>,
  (typeof TOPIC_LEVEL_2_CREATE_ALLOWED_KEYS)[number]
>;

export const TOPIC_LEVEL_2_UPDATE_ALLOWED_KEYS = [...TOPIC_LEVEL_2_CREATE_ALLOWED_KEYS] satisfies Array<
  keyof TableUpdateModel<'topics_level_02', 'categories'>
>;

export type TopicLevel2UpdateModel = Pick<
  TableUpdateModel<'topics_level_02', 'categories'>,
  (typeof TOPIC_LEVEL_2_UPDATE_ALLOWED_KEYS)[number]
>;

export interface TopicLevel2Weight {
  topic_id: TopicLevel2StoreModel['id'];
  syllabus_id: SyllabusStoreModel['id'];
  course_level: CourseLevel;
  weight: number;
}
